import React from 'react';
import {
  Card,
  Stack,
  Heading,
  TextContainer,
  Link,
  Avatar,
} from '@shopify/polaris';
import { getInitials } from 'utils/strings';

function DepositReceiver({ receiver_id, receiver_name }) {
  return receiver_name ? (
    <Card.Section
      title={
        <Stack distribution="equalSpacing">
          <Stack.Item>
            <Heading>Receiver</Heading>
          </Stack.Item>
          <Stack.Item>
            <Link url={`/customers/${receiver_id}`}>
              <Avatar
                initials={getInitials(receiver_name)}
                name={receiver_name}
                size="small"
              ></Avatar>
            </Link>
          </Stack.Item>
        </Stack>
      }
      sectioned
    >
      <TextContainer>
        <Link url={`/customers/${receiver_id}`}>{receiver_name}</Link>
      </TextContainer>
    </Card.Section>
  ) : null;
}

export default DepositReceiver;
